import { useMenuGroupProductAddonsQuery } from "@/generated/graphql";
import { useMemo } from "react";

// Loads a product's addon group items (with config + components) on demand — paused until a group is set.
export const useMenuGroupProductAddons = (
	productAddonGroupID: string | undefined,
) => {
	const options = useMemo(
		() => ({
			variables: { productAddonGroupID: productAddonGroupID ?? "" },
			pause: !productAddonGroupID,
			requestPolicy: "network-only" as const,
			context: { suspense: false },
		}),
		[productAddonGroupID],
	);

	const [result] = useMenuGroupProductAddonsQuery(options);

	return {
		items: result.data?.productAddonGroupItemsByGroupID ?? [],
		fetching: result.fetching,
		error: result.error,
	};
};
